/**
 * Straight-line geo helpers.
 *
 * Duplicated from `src/components/70mm-imax-theaters/distance.ts`, which is the
 * same maths for the same job. The two want to converge on one shared module,
 * but that folder is about to come under a living spec (nexus#649) whose
 * `owned_paths` claims it, so the move is a delta to that spec rather than a
 * free refactor here. Converge once #649 lands.
 */

/** Great-circle (haversine) distance between two points, in miles. */
export function haversineMiles(
    a: { lat: number; lng: number },
    b: { lat: number; lng: number },
): number {
    const EARTH_RADIUS_MI = 3958.8
    const toRad = (deg: number) => (deg * Math.PI) / 180
    const dLat = toRad(b.lat - a.lat)
    const dLng = toRad(b.lng - a.lng)
    const h =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * Math.sin(dLng / 2) ** 2
    return 2 * EARTH_RADIUS_MI * Math.asin(Math.sqrt(h))
}

/** Display form: "12 mi away", "1,240 mi away". Straight-line, not road. */
export function formatDistance(miles: number): string {
    return `${Math.round(miles).toLocaleString('en-US')} mi away`
}
